<template>
  <div class="ai-banner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">降低AI技术门槛 释放AI技术潜力</span>
        <p>MoPaaS 智能云平台赋能数字化未来</p>
        <div class="try-btn-area">
          <a href="https://ai.mopaas.com" target="_blank">
            <div class="btn-contactUs">立即体验</div>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home-Banner',
}
</script>

<style>
.ai-banner {
  width: 100vw;
  height: 38.5vw;
  overflow-y: hidden;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("../../assets/images/newaibanner.png");
}

.ai-banner .center {
  width: auto !important;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 4vw;
}

.ai-banner .banner-overlay1 {
  padding-top: 10vw;
  color: #FFFFFF;
  text-align: left;
}


.ai-banner .banner-overlay1 .title {
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  display: inline;
}

.ai-banner .banner-overlay1 p {
  font-size: 6px;
  font-weight:300;
  color: #FFFFFF;
  line-height: 10px;
  opacity: 0.7;
  margin-top: 6px;
}

.ai-banner .btn-contactUs {
  width: 24vw;
  margin-top: 6vw;
  height: 4vw;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 300;
  padding: 2vw;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/ai-banner.vue